const createPage = {
	title: 'Add Page',

	fieldsets: [
		{
			id: 'createPage',
			label: 'New Page',
			config: {
				rootObject: true,
				empty: true,
				method: 'post',
				action: 'createPage',
				redirect: '/dashboard/sites/{slugOne}/',
			},
			fields: [
				{
					id: 'cmsTitle',
					label: 'CMS Title',
					role: 'admin',
					validate: {
						maxLength: 20,
						required: true,
					},
				},
				{
					id: 'slug',
					label: 'Slug',
					role: 'dev',
					classNames: ['field--half'],
					validate: {
						maxLength: 20,
						required: true,
					},
				},
				{
					id: 'template',
					label: 'Template',
					role: 'dev',
					classNames: ['field--half'],
					validate: {
						alphaDash: true,
					},
				},
				{
					id: 'contentSchema',
					label: 'JSON Schema',
					role: 'dev',
					type: 'code',
					classNames: ['field--large'],
					validate: {
						json: true,
					},
				},
			],
		},
	],
};

export default createPage;
